import { useState } from 'react';
import { faBank, faPix, faStore } from '~/assets';
import { ModalCreditSimulationMethod } from '~/components';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import {
  CREDIT_SIMULATION_METHOD,
  PAYMENT_TYPE,
  showAlert,
  useStores,
} from '~/utils';
import CreditSimulationMethod from './CreditSimulationMethod';

const CreditSimulationMethodContainer = () => {
  const navigate = useNavigate();
  const { creditProducts } = useStores();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [creditSimulationMethod, setCreditSimulationMethod] =
    useState<CREDIT_SIMULATION_METHOD | null>(null);

  const paymentOptions = [
    {
      title: 'PIX',
      icon: faPix,
      onPress: () => {
        if (isLoading) return;
        setIsOpen(true);
        setCreditSimulationMethod(CREDIT_SIMULATION_METHOD.PIX);
      },
    },
    {
      title: 'SAQUE FARM. SÃO JOÃO',
      icon: faStore,
      onPress: () => {
        if (isLoading) return;
        setIsOpen(true);
        setCreditSimulationMethod(CREDIT_SIMULATION_METHOD.STORE);
      },
    },
    {
      title: 'CONTA BANCÁRIA',
      icon: faBank,
      onPress: () => {
        if (isLoading) return;
        setIsOpen(true);
        setCreditSimulationMethod(CREDIT_SIMULATION_METHOD.BANK_ACCOUNT);
      },
    },
  ];

  const handleNextAction = () => {
    if (!creditSimulationMethod) return;

    if (creditSimulationMethod === CREDIT_SIMULATION_METHOD.PIX) {
      navigate(Routes.CREDIT_SIMULATION_PIX_KEY);
      return;
    }

    if (creditSimulationMethod === CREDIT_SIMULATION_METHOD.BANK_ACCOUNT) {
      navigate(Routes.CREDIT_SIMULATION_BANK_ACCOUNT);
      return;
    }

    if (creditSimulationMethod === CREDIT_SIMULATION_METHOD.STORE) {
      handleStoreWithdrawal();
    }
  };

  const handleStoreWithdrawal = async () => {
    setIsLoading(true);
    try {
      creditProducts.setCurrentCreditSimulationRequest({
        paymentType: PAYMENT_TYPE.WITHDRAW,
      });
      await creditProducts.creditSimulation();
      navigate(Routes.CREDIT_SIMULATION_WITHDRAWAL_CONFIRMATION);
    } catch (error) {
      setIsOpen(false);
      setIsLoading(false);
      showAlert({ message: error.message || 'Erro ao realizar saque' });
    }
  };

  return (
    <>
      <CreditSimulationMethod paymentOptions={paymentOptions} />
      <ModalCreditSimulationMethod
        isOpen={isOpen}
        creditSimulationMethod={
          creditSimulationMethod || CREDIT_SIMULATION_METHOD.STORE
        }
        handleNext={handleNextAction}
      />
    </>
  );
};

export default observer(CreditSimulationMethodContainer);
